import { Box } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FareBreakdownContainer = styled(Box)`
  width: 100%;
  margin-top: 0.75rem;
  background-color: rgba(2, 136, 209, 0.04);
  border: 1px solid rgba(2, 136, 209, 0.3) !important;
  border-radius: 4px;
  padding: 0.75rem;
  color: ${colorTokens.text.medium};
`;
